var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart",attrs:{"id":"app"}},[_c('PieChart',{attrs:{"data":_vm.chartData,"pie-style":"donut","label-position":"center","legend":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }